import { __spreadArrays } from "tslib";
import isArray from './is-array';
import isFunction from './is-function';
export default function safeCallWithNull(func) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!isFunction(func)) {
        return null;
    }
    if (isArray(args[0])) {
        return func.call.apply(func, __spreadArrays([null], args[0]));
    }
    return func.call.apply(func, __spreadArrays([null], args));
}
//# sourceMappingURL=safe-call-with-null.js.map